module.exports = __webpack_public_path__ + "img/outlaw.a8ab77b8.png";